import React, { memo } from 'react';
import { Container, Image, Titulo, Line1, LogoContainer } from './bannerriograndestyles'; // Asegúrate de importar 'LogoContainer' si decides agregarlo
import fondo from './riogrande1.jpg';
import logo from './logoriogrande.png';

const BannerAcademy = () => {
  return (
    <Container>
      <Image src={fondo} alt="imagen fondo" />
      <Titulo>
        <Line1>CLUB RIO GRANDE</Line1>
        <LogoContainer>
          <img src={logo} alt="Logo" style={{ width: '100px', height: '100px', margin: '20px' }} />
        </LogoContainer>
      </Titulo>
    </Container>
  );
};

export default memo(BannerAcademy);